import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import type { Photo } from "react-photo-album";
interface PhotoAlbumResponse {
  "@context": string;
  "@id": string;
  "@type": string;
  photos: [{
    "@id": string;
    "@type": string;
    photo: {
      "@id": string;
      "@type": string;
      urls: {
        image_48_16_9: string;
        image_64_16_9: string;
        image_96_16_9: string;
        image_128_16_9: string;
        image_256_16_9: string;
        image_384_16_9: string;
        image_640_16_9: string;
        image_1080_16_9: string;
      };
      metadata: {
        size: number;
        width: number;
        height: number;
        type: string;
      };
      id: string;
    };
    id: string;
  }];
  id: string;
}
interface Club {
  slug: string;
}
export const usePhotoAlbum = club => {
  const $ = _c(11);
  const clubSlug = club.slug;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = [1080, 640, 384, 256, 128, 64, 48];
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const breakpoints = t0;
  let t1;
  if ($[1] !== clubSlug) {
    t1 = data => data.photos.map(t2 => {
      const {
        photo,
        id
      } = t2;
      return {
        id,
        src: photo.urls.image_1080_16_9,
        alt: clubSlug + " photo" + photo.id,
        width: photo.metadata.width,
        height: photo.metadata.height,
        sizes: "(max-width: 1200px) 100vw, 1200px",
        srcSet: breakpoints.map(breakpoint => ({
          src: photo.urls[`image_${breakpoint}_16_9` as keyof typeof photo.urls],
          width: breakpoint,
          height: Math.round(photo.metadata.height / photo.metadata.width * breakpoint)
        }))
      } as unknown as Photo & {
        id: string;
      };
    });
    $[1] = clubSlug;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const photosPreparation = t1;
  let t2;
  if ($[3] !== clubSlug) {
    t2 = ["club", clubSlug, "photos"];
    $[3] = clubSlug;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== clubSlug || $[6] !== photosPreparation) {
    t3 = async () => {
      const response = await fetch(`/api/club-photos?clubSlug=${clubSlug}`);
      if (!response.ok) {
        throw new Error("Erreur lors de la r\xE9cup\xE9ration des photos");
      }
      const data_1 = await response.json().then(data_0 => photosPreparation(data_0));
      if (data_1) {
        return data_1;
      }
    };
    $[5] = clubSlug;
    $[6] = photosPreparation;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== t2 || $[9] !== t3) {
    t4 = {
      queryKey: t2,
      queryFn: t3
    };
    $[8] = t2;
    $[9] = t3;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  return useQuery(t4);
};